/** Generated by build.mjs. Includes the subscription SDK and Halloween subscription adapter. Theme asset: zz-coupon-subscribe.js. */
(() => {
  // email-subscription-client.js
  var SUBSCRIPTION_API_BASE = 'https://twenty-api.z14s.com';
  var entries = /* @__PURE__ */ new Map();
  var lifetime = 7 * 864e5;
  var uuid =
    /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  var keyPattern = /^[A-Za-z0-9_-]{43}$/;
  var copy = (value) => structuredClone(value);
  function createIdempotencyKey() {
    const bytes = crypto.getRandomValues(new Uint8Array(32));
    return btoa(String.fromCharCode(...bytes))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  }
  var SubscriptionClientError = class extends Error {
    /**
     * @param {string} code 稳定的 SDK 错误码，见文件顶部错误处理说明。
     * @param {boolean} [retryable=false] 恢复建议；操作资格结合 getState 判断。
     */
    constructor(code, retryable = false) {
      super(code);
      this.name = 'SubscriptionClientError';
      this.code = code;
      this.retryable = retryable;
    }
  };
  var fail = (code, retryable) => {
    throw new SubscriptionClientError(code, retryable);
  };
  function createEmailSubscriptionClient({
    apiBase = SUBSCRIPTION_API_BASE,
    formId,
    storage,
    element,
    timeoutMs = 15e3,
    fetch: request = globalThis.fetch.bind(globalThis),
    now = Date.now,
  } = {}) {
    const pageDocument = element?.ownerDocument ?? globalThis.document;
    const pageWindow = pageDocument?.defaultView;
    if (
      element !== void 0 &&
      (!pageWindow ||
        !(element instanceof pageWindow.Element) ||
        !element.isConnected)
    )
      fail('INVALID_CONFIGURATION');
    const url = new URL(apiBase);
    const local = ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname);
    if (
      (url.protocol !== 'https:' && !(local && url.protocol === 'http:')) ||
      url.username ||
      url.password ||
      url.search ||
      url.hash ||
      url.pathname !== '/' ||
      !/^[a-z0-9-]{1,64}$/.test(formId) ||
      !Number.isFinite(timeoutMs) ||
      timeoutMs <= 0
    )
      fail('INVALID_CONFIGURATION');
    const scope = JSON.stringify([
      url.origin,
      formId,
      globalThis.location?.origin ?? 'local',
    ]);
    const storageKey = `ses:theme-client:v1:${scope}`;
    if (!entries.has(storageKey)) {
      let backing = storage;
      if (backing === void 0) {
        try {
          backing = globalThis.sessionStorage;
        } catch {
          backing = null;
        }
      }
      const entry2 = {
        record: null,
        busy: false,
        storage: backing,
        storageMode: backing ? 'session' : 'memory',
        restorationError: null,
      };
      try {
        const raw = backing?.getItem(storageKey);
        if (raw) {
          try {
            const record = JSON.parse(raw);
            if (
              record.version !== 1 ||
              record.scope !== scope ||
              !Number.isFinite(record.createdAt) ||
              record.createdAt > now() ||
              record.body?.formId !== formId ||
              typeof record.body?.idempotencyKey !== 'string' ||
              !keyPattern.test(record.body?.idempotencyKey ?? '') ||
              record.body?.consent !== true ||
              typeof record.subscribed !== 'boolean' ||
              (record.subscriptionOutcome != null &&
                !['SUBSCRIBED', 'ALREADY_SUBSCRIBED'].includes(
                  record.subscriptionOutcome,
                )) ||
              !Number.isFinite(record.nextAllowedAt) ||
              typeof record.terminal !== 'boolean' ||
              (record.requestId !== null &&
                (typeof record.requestId !== 'string' ||
                  !uuid.test(record.requestId))) ||
              (record.subscribed
                ? !uuid.test(record.requestId)
                : typeof record.body.email !== 'string')
            )
              fail('INVALID_STORED_REQUEST');
            entry2.record = record;
          } catch {
            entry2.restorationError = 'INVALID_STORED_REQUEST';
          }
        }
      } catch {
        entry2.storageMode = 'memory';
      }
      entries.set(storageKey, entry2);
    }
    const entry = entries.get(storageKey);
    let disposed = false;
    let suspended = false;
    let lifecycleEpoch = 0;
    let activeController;
    const lifetimeController = new AbortController();
    let observer;
    function dispose() {
      if (disposed) return;
      disposed = true;
      lifecycleEpoch++;
      observer?.disconnect();
      activeController?.abort();
      lifetimeController.abort();
    }
    if (pageWindow) {
      const options = { signal: lifetimeController.signal };
      pageWindow.addEventListener(
        'pagehide',
        (event) => {
          if (event.persisted) {
            suspended = true;
            lifecycleEpoch++;
            activeController?.abort();
          } else dispose();
        },
        options,
      );
      pageWindow.addEventListener(
        'pageshow',
        () => {
          suspended = false;
        },
        options,
      );
      if (element) {
        const verifyElement = () => {
          if (disposed) return;
          if (!element.isConnected || element.ownerDocument !== pageDocument)
            dispose();
          else {
            observer.disconnect();
            let node = element;
            while (node) {
              const root = node.getRootNode();
              observer.observe(root, { childList: true, subtree: true });
              node = root.host;
            }
          }
        };
        observer = new pageWindow.MutationObserver(() =>
          queueMicrotask(verifyElement),
        );
        observer.observe(pageDocument, { childList: true, subtree: true });
        verifyElement();
        pageDocument.addEventListener(
          'shopify:section:unload',
          (event) => {
            const section =
              event.target?.nodeType === 1
                ? event.target
                : event.detail?.sectionId
                  ? pageDocument.getElementById(
                      `shopify-section-${event.detail.sectionId}`,
                    )
                  : null;
            if (section?.contains(element)) dispose();
          },
          { ...options, capture: true },
        );
      }
    }
    function save() {
      if (entry.storageMode !== 'session') return;
      try {
        if (entry.record)
          entry.storage.setItem(storageKey, JSON.stringify(entry.record));
        else entry.storage.removeItem(storageKey);
      } catch {
        entry.storageMode = 'memory';
        try {
          entry.storage?.removeItem(storageKey);
        } catch {}
      }
    }
    function getState() {
      const r = entry.record;
      const expired = Boolean(r && now() >= r.createdAt + lifetime);
      const retryAfterSeconds = Math.max(
        0,
        Math.ceil(((r?.nextAllowedAt ?? 0) - now()) / 1e3),
      );
      const usable = Boolean(
        r &&
          !expired &&
          !r.terminal &&
          !entry.restorationError &&
          !disposed &&
          !suspended &&
          !entry.busy &&
          retryAfterSeconds === 0,
      );
      return copy({
        disposed,
        suspended,
        hasRequest: Boolean(r),
        busy: entry.busy,
        subscribed: r?.subscribed ?? false,
        subscriptionOutcome: r?.subscriptionOutcome ?? null,
        requestId: r?.requestId ?? null,
        reward: r?.reward ?? null,
        discountCode: r?.discountCode ?? null,
        lastResult: r?.lastResult ?? null,
        expired,
        retryAfterSeconds,
        canRetry: usable && !r.subscribed,
        canCheckReward: usable && r.subscribed,
        terminal: r?.terminal ?? false,
        restorationError: entry.restorationError,
        storageMode: entry.storageMode,
      });
    }
    function check() {
      if (disposed) fail('CLIENT_DISPOSED');
      if (suspended) fail('CLIENT_SUSPENDED', true);
      if (entry.restorationError) fail(entry.restorationError);
      const r = entry.record;
      if (r && now() >= r.createdAt + lifetime) fail('RECEIPT_EXPIRED');
      if (r?.terminal) fail('REQUEST_TERMINATED');
      if (r && now() < r.nextAllowedAt) fail('RETRY_COOLDOWN', true);
    }
    async function exclusive(fn) {
      if (disposed) fail('CLIENT_DISPOSED');
      if (entry.busy) fail('REQUEST_IN_FLIGHT', true);
      entry.busy = true;
      try {
        return await fn();
      } finally {
        entry.busy = false;
      }
    }
    async function send(query) {
      const r = entry.record;
      const body = query
        ? {
            formId,
            requestId: r.requestId,
            idempotencyKey: r.body.idempotencyKey,
          }
        : r.body;
      const epoch = lifecycleEpoch;
      const controller = new AbortController();
      activeController = controller;
      let timedOut = false;
      const timer = setTimeout(() => {
        timedOut = true;
        controller.abort();
      }, timeoutMs);
      try {
        const response = await request(
          `${url.origin}/api/public/email-subscriptions${query ? '/reward-result' : ''}`,
          {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            cache: 'no-store',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
            signal: controller.signal,
          },
        );
        const data = await response.json();
        if (disposed) fail('CLIENT_DISPOSED');
        if (epoch !== lifecycleEpoch) fail('CLIENT_SUSPENDED', true);
        if (
          !data ||
          !['subscribed', 'error'].includes(data.status) ||
          (data.status === 'subscribed' && !response.ok) ||
          (data.subscriptionOutcome !== void 0 &&
            !['SUBSCRIBED', 'ALREADY_SUBSCRIBED'].includes(
              data.subscriptionOutcome,
            ))
        )
          fail('INVALID_RESPONSE', true);
        if (
          (data.requestId !== void 0 &&
            (typeof data.requestId !== 'string' ||
              !uuid.test(data.requestId) ||
              (r.requestId && r.requestId !== data.requestId))) ||
          (data.idempotencyKey !== void 0 &&
            data.idempotencyKey !== r.body.idempotencyKey)
        ) {
          r.terminal = true;
          save();
          fail('RECEIPT_MISMATCH');
        }
        if (data.status === 'subscribed' && !(data.requestId ?? r.requestId))
          fail('INVALID_RESPONSE', true);
        if (
          data.status === 'error' &&
          (typeof data.retryable !== 'boolean' || typeof data.code !== 'string')
        )
          fail('INVALID_RESPONSE', true);
        const header = response.headers.get('Retry-After');
        const headerSeconds = header
          ? /^\d+$/.test(header)
            ? Number(header)
            : (Date.parse(header) - now()) / 1e3
          : 0;
        const delay = Math.max(
          0,
          Number.isFinite(headerSeconds) ? headerSeconds : 0,
          Number.isFinite(data.retryAfterSeconds) ? data.retryAfterSeconds : 0,
        );
        r.nextAllowedAt = now() + delay * 1e3;
        r.requestId = data.requestId ?? r.requestId;
        r.terminal = data.status === 'error' && data.retryable === false;
        if (data.status === 'subscribed') {
          r.subscribed = true;
          r.subscriptionOutcome =
            data.subscriptionOutcome ?? r.subscriptionOutcome ?? null;
          delete r.body.email;
        }
        if (data.reward && typeof data.reward === 'object')
          r.reward = copy(data.reward);
        if (typeof data.reward?.code === 'string' && data.reward.code)
          r.discountCode = data.reward.code;
        const result = {
          httpStatus: response.status,
          status: data.status,
          subscriptionOutcome: r.subscriptionOutcome ?? null,
          requestId: r.requestId,
          ...(data.status === 'error'
            ? {
                code: data.code,
                retryable: data.retryable,
                message:
                  typeof data.message === 'string' ? data.message : void 0,
              }
            : {}),
          retryAfterSeconds: delay,
          reward: copy(r.reward),
        };
        r.lastResult = result;
        save();
        return copy(result);
      } catch (error) {
        if (error instanceof SubscriptionClientError) throw error;
        fail(
          disposed
            ? 'CLIENT_DISPOSED'
            : epoch !== lifecycleEpoch
              ? 'CLIENT_SUSPENDED'
              : timedOut
                ? 'REQUEST_TIMEOUT'
                : 'RESULT_UNCONFIRMED',
          !disposed,
        );
      } finally {
        clearTimeout(timer);
        activeController = void 0;
      }
    }
    return {
      signal: lifetimeController.signal,
      getState,
      /**
       * 发起一次新订阅；发送前生成并保存原请求。已有请求优先通过 retry/checkReward 恢复。
       * Promise resolve 包含 subscribed 或业务 error；SDK 异常走 reject。
       * @param {SubscriptionInput} input 邮箱和用户实际同意状态。
       * @returns {Promise<SubscriptionResult>}
       * @throws {SubscriptionClientError} Promise 拒绝原因包含输入、阶段、冷却及传输错误。
       */
      submit({ email, consent } = {}) {
        return exclusive(async () => {
          check();
          if (entry.record) fail('EXISTING_REQUEST_REQUIRES_RECOVERY');
          if (consent !== true || typeof email !== 'string')
            fail('INVALID_INPUT');
          email = email.trim();
          if (
            email.length > 254 ||
            !/^[\x21-\x7e]+$/.test(email) ||
            !/^[^@]+@[^@]+$/.test(email)
          )
            fail('INVALID_INPUT');
          const key = createIdempotencyKey();
          entry.record = {
            version: 1,
            scope,
            createdAt: now(),
            nextAllowedAt: 0,
            requestId: null,
            subscribed: false,
            terminal: false,
            reward: null,
            discountCode: null,
            lastResult: null,
            body: { formId, email, consent: true, idempotencyKey: key },
          };
          save();
          return send(false);
        });
      },
      /**
       * 用户触发的订阅恢复：提交保存的原邮箱、同意项和 key，适用于结果未知或可恢复错误。
       * 调用前检查 canRetry；确认订阅成功后切换到 checkReward。
       * @returns {Promise<SubscriptionResult>}
       * @throws {SubscriptionClientError} Promise 拒绝原因包含状态保护及传输错误。
       */
      retry() {
        return exclusive(async () => {
          check();
          if (!entry.record || entry.record.subscribed)
            fail('SUBMISSION_RETRY_UNAVAILABLE');
          return send(false);
        });
      },
      /**
       * 查询已确认订阅的原奖励，发送 formId、requestId 和原 key。
       * 调用前检查 canCheckReward；页面保留既有订阅成功及 discountCode。
       * @returns {Promise<SubscriptionResult>}
       * @throws {SubscriptionClientError} Promise 拒绝原因包含状态保护及传输错误。
       */
      checkReward() {
        return exclusive(async () => {
          check();
          if (!entry.record?.subscribed || !entry.record.requestId)
            fail('REWARD_QUERY_UNAVAILABLE');
          return send(true);
        });
      },
      /**
       * 用户明确开始新提交时调用。清除同范围共享记录，下次 submit 生成新的 key。
       * 服务端原任务继续处理；先由页面结束该请求的自动查询，再调用 reset。
       * @returns {void}
       * @throws {SubscriptionClientError} CLIENT_DISPOSED 或 REQUEST_IN_FLIGHT。
       */
      reset() {
        if (disposed) fail('CLIENT_DISPOSED');
        if (entry.busy) fail('REQUEST_IN_FLIGHT', true);
        entry.record = null;
        entry.restorationError = null;
        save();
      },
      /**
       * 释放当前实例并中止其在途传输。保存记录继续供新实例恢复，服务端任务按自身状态执行。
       * element/page 生命周期自动调用；高级调用方也可主动使用，多次调用可安全执行。
       * signal 同步触发 abort，示例控制器跟随释放事件和查询定时器。
       * @returns {void}
       */
      dispose,
    };
  }

  // sdk-entry.js
  if (window.TwentyEmailSubscription === void 0) {
    window.TwentyEmailSubscription = Object.freeze({
      createClient: createEmailSubscriptionClient,
      SubscriptionClientError,
    });
  } else if (
    !window.TwentyEmailSubscription ||
    typeof window.TwentyEmailSubscription.createClient !== 'function' ||
    typeof window.TwentyEmailSubscription.SubscriptionClientError !== 'function'
  ) {
    throw new Error('TwentyEmailSubscription namespace is already occupied');
  }

  // halloween.js
  var mounted = /* @__PURE__ */ new WeakMap();
  var failure = 'Something went wrong. Please try again later.';
  function mountHalloweenSubscription(root) {
    if (mounted.has(root)) return mounted.get(root);
    const config = root.querySelector('[data-twenty-coupon]');
    const form = root.querySelector('.zz-coupon__form');
    const dialog = root.querySelector('.zz-coupon-modal');
    if (!config || !form || !dialog) return;
    const emailInput = form.querySelector('input[type="email"]');
    const consent = form.querySelector('.zz-coupon__checkbox');
    const button = form.querySelector('.zz-coupon__submit');
    const successPanel = dialog.querySelector('.zz-coupon-modal__success');
    const unavailablePanel = dialog.querySelector(
      '.zz-coupon-modal__unavailable',
    );
    const apiBase = SUBSCRIPTION_API_BASE;
    const formId = config.dataset.formId;
    const scope = JSON.stringify([apiBase, formId, location.origin]);
    const client = window.TwentyEmailSubscription.createClient({
      apiBase,
      formId,
      element: root,
    });
    const storageKey = `ses:halloween:v1:${scope}`;
    let meta = {};
    try {
      meta = JSON.parse(sessionStorage.getItem(storageKey)) || {};
    } catch {}
    if (typeof meta !== 'object' || Array.isArray(meta)) meta = {};
    if (!client.getState().hasRequest) meta = {};
    if (client.getState().subscribed) delete meta.email;
    let running = false;
    let cooldownTimer;
    let epoch = 0;
    let trackedEmail = '';
    // 记录弹窗打开时刻，用于跳过「打开弹窗的那一次点击」自身
    let openedAt = 0;
    const toast = (message, type = 'error') =>
      window.zzShowToast?.(message, { type });
    const listen = (target, event, handler) =>
      target.addEventListener(event, handler, { signal: client.signal });
    const save = () => {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(meta));
      } catch {}
    };
    const hashEmail = async (email) =>
      Array.from(
        new Uint8Array(
          await crypto.subtle.digest(
            'SHA-256',
            new TextEncoder().encode(email.toLowerCase()),
          ),
        ),
        (byte) => byte.toString(16).padStart(2, '0'),
      ).join('');
    function showSubscriptionPanel() {
      const alreadySubscribed =
        client.getState().subscriptionOutcome === 'ALREADY_SUBSCRIBED' &&
        Boolean(unavailablePanel);
      if (successPanel)
        successPanel.style.display = alreadySubscribed ? 'none' : '';
      if (unavailablePanel) {
        unavailablePanel.style.display = alreadySubscribed ? '' : 'none';
        unavailablePanel.classList.toggle('tw-hidden', !alreadySubscribed);
      }
    }
    function showSubscriptionSuccess() {
      const state2 = client.getState();
      if (!state2.subscribed) return;
      if (meta.trackedRequestId !== state2.requestId) {
        window.dataLayer?.push({
          event: 'coupon-subscribe',
          timestamp: /* @__PURE__ */ new Date().toISOString(),
          ...(trackedEmail ? { email: trackedEmail } : {}),
        });
        window.fbq?.('track', 'CompleteRegistration');
        meta.trackedRequestId = state2.requestId;
        save();
      }
      trackedEmail = '';
      form.reset();
      showSubscriptionPanel();
      if (!dialog.open) {
        openedAt = performance.now();
        // show() 而非 showModal()：显示在本 block 卡片内，不进入 top layer、不生成蒙层
        if (typeof dialog.show === 'function') dialog.show();
        else dialog.setAttribute('open', 'open');
      }
    }
    listen(dialog, 'close', showSubscriptionPanel);
    // 点击弹窗面板之外任意位置关闭。判定用「按下→抬起」的位移而非 click：
    // 本 block 是 swiper slide，拖拽轮播结束时浏览器同样会派发 click，
    // 直接监听 click 会在一滑到底时误关弹窗，故要求位移小于阈值才算点击。
    let downPoint = null;
    listen(document, 'pointerdown', (event) => {
      downPoint = { x: event.clientX, y: event.clientY };
    });
    listen(document, 'pointerup', (event) => {
      if (!dialog.open || !downPoint) return;
      const moved = Math.hypot(
        event.clientX - downPoint.x,
        event.clientY - downPoint.y,
      );
      downPoint = null;
      // 拖拽（轮播）不关；打开弹窗的那次交互本身也忽略，避免「一点就关」
      if (moved > 10 || performance.now() - openedAt < 100) return;
      const panel = event.target?.closest?.('.zz-coupon-modal__panel');
      // 面板内（含关闭按钮、协议链接）不关；其余一律关闭
      if (panel && dialog.contains(panel)) return;
      dialog.close();
    });
    // 非模态 dialog（show()）不响应 Esc，补上
    listen(document, 'keydown', (event) => {
      if (event.key === 'Escape' && dialog.open) dialog.close();
    });
    function render() {
      clearTimeout(cooldownTimer);
      const state2 = client.getState();
      if (state2.disposed || state2.suspended) return;
      const loading = running || state2.busy;
      form.classList.toggle('is-loading', loading);
      form.setAttribute('aria-busy', String(loading));
      button.disabled = loading || state2.retryAfterSeconds > 0;
      // 只在请求进行中锁输入。不能用 hasRequest 判断：
      // submit() 是「先落盘再发请求」，接口失败（如 403）后记录仍在，
      // 用 hasRequest 会把邮箱框和协议框永久钉死，连改邮箱重试都做不到。
      emailInput.disabled = loading;
      if (consent) consent.disabled = loading;
      if (state2.retryAfterSeconds > 0 || state2.busy)
        cooldownTimer = setTimeout(render, 250);
    }
    function present(result) {
      const state2 = client.getState();
      if (state2.subscribed) {
        delete meta.email;
        save();
      }
      if (result?.status === 'error') {
        toast(failure);
        return;
      }
      if (state2.subscribed) showSubscriptionSuccess();
      else toast(failure);
    }
    listen(form, 'submit', async (event) => {
      event.preventDefault();
      let state2 = client.getState();
      if (
        running ||
        state2.busy ||
        state2.suspended ||
        state2.retryAfterSeconds > 0
      )
        return;
      // 上一次请求已走进死路（过期 / 存储损坏 / 不可重试的错误，如 403）时，
      // 清掉旧记录重新开始，而不是 toast 后 return —— 否则用户永远提交不了。
      if (
        (state2.expired && !state2.subscribed) ||
        state2.restorationError ||
        (state2.terminal && !state2.subscribed)
      ) {
        try {
          client.reset();
        } catch {
          // reset() 在请求在途时会抛错，这种情况才真的没法继续
          toast(failure);
          return;
        }
        meta = {};
        save();
        state2 = client.getState();
      }
      const email = emailInput.value.trim();
      // 已订阅且没填新邮箱 —— 直接复显成功弹窗，无需校验
      const reshowing = state2.subscribed && !email;
      if (!reshowing) {
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          toast('Please enter a valid email address');
          emailInput.focus();
          return;
        }
        if (!consent?.checked) {
          toast('Please agree to the data protection policy');
          return;
        }
      }
      running = true;
      const operationEpoch = epoch;
      render();
      try {
        const emailHash = email ? await hashEmail(email) : null;
        if (client.signal.aborted || operationEpoch !== epoch) return;
        state2 = client.getState();
        // 邮箱与上次提交的不一致就丢弃旧记录重新提交，
        // 否则会走 retry() 拿旧邮箱重发，用户改了邮箱也看不出变化。
        if (
          state2.hasRequest &&
          emailHash &&
          emailHash !== meta.emailHash &&
          !state2.busy
        ) {
          client.reset();
          meta = {};
          save();
          state2 = client.getState();
        }
        let result;
        if (!state2.hasRequest) {
          meta = { email, emailHash };
          trackedEmail = email;
          save();
          result = await client.submit({ email, consent: consent.checked });
        } else if (!state2.subscribed) {
          trackedEmail = meta.email || '';
          result = await client.retry();
        } else {
          showSubscriptionSuccess();
          return;
        }
        if (!client.signal.aborted && operationEpoch === epoch) present(result);
      } catch {
        if (!client.signal.aborted && operationEpoch === epoch) toast(failure);
      } finally {
        if (operationEpoch === epoch) running = false;
        render();
      }
    });
    listen(window, 'pagehide', (event) => {
      if (event.persisted) {
        epoch++;
        running = false;
        clearTimeout(cooldownTimer);
      }
    });
    listen(window, 'pageshow', (event) => {
      if (event.persisted) {
        render();
      }
    });
    client.signal.addEventListener(
      'abort',
      () => {
        epoch++;
        clearTimeout(cooldownTimer);
        dialog.close?.();
        mounted.delete(root);
      },
      { once: true },
    );
    mounted.set(root, client);
    const state = client.getState();
    if (state.hasRequest && !state.subscribed) {
      emailInput.value = meta.email || '';
      if (consent) consent.checked = true;
    }
    save();
    render();
    return client;
  }

  // halloween-entry.js
  if (!window.TwentyHalloweenSubscription) {
    window.TwentyHalloweenSubscription = Object.freeze({
      mount: mountHalloweenSubscription,
    });
    const mountAll = (scope) => {
      scope.querySelectorAll('[data-twenty-coupon]').forEach((element) => {
        const root = element.closest('.shopify-block');
        if (root) mountHalloweenSubscription(root);
      });
    };
    document.addEventListener('shopify:section:load', (event) =>
      mountAll(event.target),
    );
    if (document.readyState === 'loading')
      document.addEventListener('DOMContentLoaded', () => mountAll(document), {
        once: true,
      });
    else mountAll(document);
  }
})();
